
  import moment from 'moment';
  import { Component, Prop, Vue} from "vue-property-decorator";
  import { mcDate } from '@/utils'

  @Component
  export default class McServingLineSummary extends Vue {
      @Prop({default: "Unknown User"}) readonly name!: string
      @Prop({default: moment.now().toString()}) readonly datetime!: string
      @Prop({default: 0}) readonly count!: number

      get localTime() {
          const local = mcDate.utcToLocal(this.datetime);
          const localTime = mcDate.isToday(local) ? mcDate.toTime(local) : mcDate.toDateTime(local);
          return localTime;
      }
  }
